import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import Navbar from './Dashboard/Navbar'
import Activity from './Dashboard/Activity'


export default function Dashboard() {

  const navigate = useNavigate()


  useEffect(() => {

    if (!localStorage.getItem('access_token')) {
      navigate('/auth/signin/')
    }

  }, [navigate])


  return (

    <div className="
      min-h-screen
      bg-[#F7F9FC]
    ">

      <Navbar />

      <Activity />

    </div>
  )
}